import { Children, PropsWithChildren, useEffect, useRef } from 'react';

import useEmblaCarousel from 'embla-carousel-react';
import styled from '@emotion/styled';

type Props = {
  initialSlideIndex?: number;
};

export default function LocalNavCarousel({
  children,
  initialSlideIndex,
}: PropsWithChildren<Props>) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    containScroll: 'trimSnaps',
    align: 'start',
  });

  // swiper initialSlide처럼 초기화 시 1회만 반영한다. deps에 initialSlideIndex를 두면
  // prop 변경 시마다 강제 re-scroll이 발생하므로 초기값을 ref로 캡처해 emblaApi 준비 시점에만 스크롤한다.
  const initialSlideIndexRef = useRef(initialSlideIndex);
  useEffect(() => {
    if (emblaApi && initialSlideIndexRef.current != null) {
      emblaApi.scrollTo(initialSlideIndexRef.current, true);
    }
  }, [emblaApi]);

  return (
    <Container>
      <Viewport ref={emblaRef}>
        <Track>
          {Children.map(children, (child) => (
            <Slide>{child}</Slide>
          ))}
        </Track>
      </Viewport>
    </Container>
  );
}

const Container = styled.div`
  overflow: hidden;
  display: flex;
  width: 100%;
  height: 100%;
`;

const Viewport = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
`;

const Track = styled.div`
  display: flex;
  height: 100%;
  padding: 0 8px;
`;

const Slide = styled.div`
  flex: 0 0 auto;
  min-width: 0;
  height: 100%;
`;
